import { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { LoginPage } from '../../pages/LoginPage';

interface AdminGuardProps {
  children: ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { user, loading, isAuthenticated, isAdmin, isContributor } = useAuth();

  if (loading) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-gray-100'>
        <div className='text-center'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600 mx-auto'></div>
          <p className='mt-4 text-gray-600'>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (!isAdmin && !isContributor) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-gray-100'>
        <div className='bg-white p-8 rounded-lg shadow-md max-w-md text-center'>
          <div className='text-red-500 text-5xl mb-4'>⛔</div>
          <h1 className='text-2xl font-bold text-gray-900 mb-2'>
            Access Denied
          </h1>
          <p className='text-gray-600 mb-4'>
            You don&apos;t have admin or contributor privileges. Please contact
            an administrator if you believe this is an error.
          </p>
          <p className='text-sm text-gray-500 mb-2'>
            Logged in as: {user?.email}
          </p>
          <p className='text-xs text-gray-400 mb-4'>UID: {user?.uid}</p>
          <p className='text-xs text-gray-400 mb-4'>
            Check browser console (F12) for debug info
          </p>
          <button
            onClick={() => window.location.reload()}
            className='px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700'
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
